import { closableQueue } from '@composable/useClosable';

export default defineNuxtRouteMiddleware(to => {
    const router = useRouter();
    if (import.meta.server) {
        return;
    }
    if (
        to.fullPath === router.options.history.state.back ||
        to.fullPath === router.options.history.state.current
    ) {
        if (closableQueue.value.length) {
            closableQueue.value.shift();
            return abortNavigation();
        }
    } else {
        closableQueue.value = [];
    }
});
